var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.385 46.69H16.56l2.406-14.458h3.824L20.385 46.69Zm-7.058-14.458L9.66 42.167l-.433-2.126-1.302-6.533s-.157-1.315-1.813-1.315H.079l-.079.27s1.853.387 4.022 1.663l3.351 12.565h3.983l6.111-14.46h-4.14ZM43.49 46.69H47l-3.075-14.458h-3.076c-1.42 0-1.774 1.082-1.774 1.082l-5.678 13.377h3.982l.789-2.165h4.89l.433 2.165Zm-4.218-5.141 2.01-5.412 1.144 5.412h-3.154Zm-5.599-5.838.552-3.093S32.529 32 30.755 32c-1.892 0-6.427.812-6.427 4.794 0 3.75 5.323 3.789 5.323 5.76 0 1.972-4.77 1.624-6.348.387l-.552 3.247s1.695.812 4.337.812c2.603 0 6.585-1.315 6.585-4.949 0-3.75-5.363-4.097-5.363-5.76 0-1.7 3.707-1.469 5.363-.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.227 40.003-1.302-6.495s-.157-1.315-1.813-1.315H.079l-.079.27s2.918.58 5.678 2.823c2.681 2.088 3.549 4.717 3.549 4.717Z",
    fill: "#FAA634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.313 2.78H17.686v20.44h11.627V2.78Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.425 13c0-4.153 1.993-7.836 5.057-10.22A13.392 13.392 0 0 0 15.288 0C7.942 0 2 5.814 2 13s5.942 13 13.288 13c3.1 0 5.942-1.047 8.194-2.78A12.88 12.88 0 0 1 18.425 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 13c0 7.186-5.942 13-13.287 13a13.39 13.39 0 0 1-8.194-2.78c3.1-2.384 5.056-6.067 5.056-10.22 0-4.153-1.993-7.836-5.056-10.22A13.391 13.391 0 0 1 31.713 0C39.058 0 45 5.85 45 13Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "38_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h47v47H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg47);
export default __webpack_public_path__ + "static/media/47.1f20f1ac355035387e86785b55efa226.svg";
export { ForwardRef as ReactComponent };